/**
 * ロゴタイプ (スプリ)。
 *
 * assets/brand/spli-logo.svg を取り込んだもの。元ファイルは fill に
 * ブランド色 (#0a7d6d) を直接持っているが、ここでは currentColor にしてある。
 * ダークテーマではヘッダーの背景が暗くなり、そのままの色ではコントラストが
 * 足りないため、色は CSS 側 (--color-primary) で決める。
 *
 * 元ファイルを差し替えたときは、path をここに写し直すこと。
 */
export interface SpliLogoProps {
  /** 高さ (px)。幅は縦横比から決まる */
  height?: number;
  className?: string;
}

/** 元データの縦横比 (viewBox から) */
const ASPECT_RATIO = 675.85 / 207.96;

export function SpliLogo({ height = 22, className }: SpliLogoProps) {
  return (
    <svg
      className={className}
      viewBox="0 0 675.85 207.96"
      height={height}
      width={Math.round(height * ASPECT_RATIO)}
      fill="currentColor"
      role="img"
      aria-label="スプリ"
    >
      <path d="M286.92,206.43c-2.91,0-5.63-.91-8.06-2.7-3.01-2.21-4.88-5.21-5.59-8.91-.73-3.44.05-6.72,2.32-9.7,2.22-2.94,5.16-4.7,8.73-5.23,37.07-5.25,65.02-17.37,83.07-36.03,17.98-18.58,28.34-46.38,30.77-82.65h-133.46c-3.74,0-6.95-1.31-9.54-3.91-2.59-2.58-3.9-5.79-3.9-9.54s1.31-6.95,3.9-9.54c2.59-2.59,5.8-3.9,9.54-3.9h127.29v-.29c0-9.36,3.35-17.45,9.97-24.07s14.71-9.97,24.07-9.97,17.45,3.35,24.07,9.97c6.62,6.62,9.97,14.71,9.97,24.07s-3.35,17.46-9.97,24.07c-6.51,6.51-14.46,9.86-23.63,9.96.11,1.57.09,3.28-.05,5.03-4.47,39.57-18.14,70.54-40.66,92.13-22.48,21.55-55.04,35.36-96.77,41.04-.7.1-1.41.15-2.09.15ZM426.05,21.16c-3.6,0-6.58,1.23-9.11,3.76-2.53,2.53-3.76,5.51-3.76,9.11s1.23,6.58,3.76,9.11c2.53,2.53,5.51,3.76,9.11,3.76s6.58-1.23,9.11-3.76,3.76-5.51,3.76-9.11-1.23-6.58-3.76-9.11c-2.53-2.53-5.51-3.76-9.11-3.76Z" />
      <path d="M165.45,207.96c-3.98-.09-7.4-1.55-10.18-4.33-20.52-20.82-39.17-38.94-55.44-53.87-23.58,21.87-50.18,40.56-78.98,55.49-2.12,1.12-4.33,1.68-6.54,1.68-1.44,0-2.9-.24-4.34-.72-3.62-1.21-6.39-3.51-8.24-6.84-1.9-3.42-2.24-7-.99-10.62,1.2-3.52,3.5-6.25,6.83-8.1,29.12-15.69,54.64-34.14,75.87-54.84,20.51-20,36.8-41.59,48.45-64.19H29.92c-3.77,0-7.06-1.38-9.78-4.1-2.72-2.71-4.1-6-4.1-9.78s1.38-7.06,4.1-9.78c2.72-2.72,6.01-4.1,9.78-4.1h121.74c3.77,0,7.06,1.38,9.78,4.1,2.72,2.73,4.1,6.02,4.1,9.78,0,8.15-1.63,15.63-4.85,22.22-9.73,20.21-23.55,40.33-41.09,59.77,20.77,19.13,39.66,37.18,56.14,53.66,2.8,2.8,4.21,6.24,4.21,10.24s-1.42,7.44-4.21,10.24c-2.72,2.72-6.06,4.1-9.92,4.1h-.37Z" />
      <path d="M567.46,207.68c-3.06,0-5.93-.94-8.53-2.8-3.2-2.29-5.28-5.39-6.19-9.22-.78-3.87-.06-7.37,2.12-10.49,2.15-3.09,5.13-5.03,8.87-5.78,30.25-5.37,51.54-15.22,63.36-29.31,11.81-14.09,17.8-36.46,17.8-66.48v-48.51c0-4.22,1.53-7.9,4.56-10.92,3.02-3.02,6.7-4.56,10.92-4.56s7.9,1.53,10.92,4.56c3.02,3.02,4.56,6.7,4.56,10.92v47.83c0,37.4-8.53,66.35-25.35,86.06-16.82,19.7-44,32.67-80.79,38.55-.78.11-1.53.17-2.25.17ZM542.74,126.77c-4.08,0-7.64-1.5-10.58-4.44-2.95-2.94-4.44-6.58-4.44-10.81V34.85c0-4.22,1.5-7.86,4.44-10.81s6.51-4.44,10.58-4.44,7.9,1.53,10.92,4.56c3.02,3.02,4.56,6.62,4.56,10.7v76.66c0,4.07-1.53,7.67-4.56,10.69-3.02,3.02-6.7,4.56-10.92,4.56Z" />
    </svg>
  );
}
